
import { Component, Inject, inject, Optional } from "@angular/core"
import { Logger } from "./logger"
import { MAT_SNACK_BAR_DATA, MatSnackBar, MatSnackBarRef } from "@angular/material/snack-bar"
import { MatIconModule } from "@angular/material/icon"
const log = new Logger("ui error")

export interface UiErrorCatcherData {
  message: string
}

export const uiErrorCatcher = async<T>(fn: Promise<T>, snackBar: MatSnackBar, defaultErrorMessage: string): Promise<T> => {
  try {
    return await fn
  } catch (error: any) {
    console.log({error})
    log.error(`${defaultErrorMessage}:\nMessage: ${error.message}\nStack: ${error.stack}`) // log stack trace for firebase logs
    snackBarError(defaultErrorMessage +": "+error.message, snackBar)
    throw new Error('Stopped function ')
  }
}

export const snackBarError = (message: string, snackBar: MatSnackBar) => {
  const data: UiErrorCatcherData = {message}
  snackBar.openFromComponent(UiErrorSnackComponent, {
    data,
    duration: 25 * 1000,
    horizontalPosition: 'start',
    verticalPosition: 'top',
    panelClass: '!text-orange-900'
  })
}

@Component({
  selector: 'snack-bar-component-example-snack',
  imports: [MatIconModule],
  template: `
  <div class="flex flex-row justify-between gap-5">
    <div class="text-red-400 flex items-center gap-3 overflow-auto">
      <mat-icon>error</mat-icon> {{data.message}}
    </div>
    <div matSnackBarActions>
      <button mat-button matSnackBarAction (click)="snackBarRef.dismissWithAction()"><mat-icon>close</mat-icon></button>
    </div>
  </div>
  `,
  styles: ``,
  standalone: true,
})
export class UiErrorSnackComponent {
  snackBarRef = inject(MatSnackBarRef);
  constructor(
    @Inject(MAT_SNACK_BAR_DATA) public data: UiErrorCatcherData,
  ){
    console.log(this.data)
  }
}

